export default "__VITE_ASSET__68b5dce3__"